import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import Technician from '../../models/Technician.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = () => {
  const navigate = useNavigate();
  const params = useParams();
  let technicianObj = new Technician({service_center_id: params.service_center_id});
  const [technician, setTechnician] = useState(technicianObj.toStateJson());
  const [createApi] = getApi('createTechnician');

  const createRecord = async (parameters) => {
    try {
      await createApi(parameters).unwrap();
      toast.success("Technician Created Successfully")
      navigate( `/service_centers/${params.service_center_id}`)
    } catch (error) {
      toast.error(error.data.message)
      technicianObj.set_api_errors(error.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord(new Technician(technician).toApiJson());
    } catch(error){
      setTechnician(new Technician(technician));
    }
  }

  const handleCancelFunction = () => {
    navigate(`/service_centers/${params.service_center_id}`);
  }

  return <PageContentWrapper contentHeading={"Create New Technician"}>
    <div className='m-3'>
      <div className='mb-4 col-md-12'>
        <form className="row g-3" autoComplete="off">
          <FormPartial technician={technician} setTechnician={setTechnician} />
          <div className='mb-4 col-md-12'>
            <div>
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Technician</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </PageContentWrapper>
}

export default New;
